<template>
  <div class="yjh-upload">
    <Upload
      ref="upload"
      :max-size="maxSize"
      :on-exceeded-size="overSizeFn"
      :on-format-error="fileTypeErrFn"
      :format="fileType"
      :accept="fileAccept"
      :action="url"
      :before-upload="beforeUpload"
      :on-success="successUpload"
      :on-error="errorUpload">
      <Input v-model="fileName" placeholder="选择本地文件" :readonly="true" :style="{'width': width }" />
    </Upload>
    <div class="link-btn yjh-active" :class="{'yjh-active-channel': comType === 'channel'}" v-click-out="clickOut">
      <span @click="scanImg" class="scan-btn" v-if="hasScan">预览</span>
      <span @click.stop="selFile">{{ (file === null && !fileName) ? '上传文件' : '重新上传' }}</span>
      <img :src="fileurl" alt="" class="scan-img" v-if="showImg">
    </div>
  </div>
</template>

<script>
// props参数
// stopUpload 是否终止自动上传，非必填，终止上传的话emit触发beforeUpload事件
// url 上传地址，必填
// width 输入input的宽度，非必填，默认210px
// max 文件最大大小，非必填，默认1000M
// overSizeToast 文件超大小toast，非必填，默认“上传文件大小超过限制“
// fileType 限制文件类型，非必填，数组，格式：['bmp', 'gif']
// fileTypeErrToast 文件格式错误toast,非必填，默认“上传文件格式不正确“

// emit事件
// 终止上传，触发beforeUpload
// 上传成功，触发successUpload
// 上传失败，触发

export default {
  data() {
    return {
      fileName: '', // 图片名字
      fileurl: 'http://101.201.103.211:8020/public/BP2V0zWYd4Fa9mvqhKsjxbEhUPAao97r2Qksntfq.jpeg', // 图片地址
      file: null,
      showImg: false // 是否展示预览图片
    }
  },
  computed: {
    maxSize() {
      return this.max * 1024 // 单位是kb
    },
    fileAccept() {
      if (this.fileType !== undefined) {
        return this.fileType.map(item => {
          return '.' + item
        }).join(',')
      } else {
        return ''
      }
    }
  },
  props: {
    stopUpload: {
      type: Boolean,
      default: false
    },
    url: String,
    width: {
      type: String,
      default: '210px'
    },
    max: {
      type: Number,
      default: 1000
    },
    overSizeToast: {
      type: String,
      default: '上传文件大小超过限制'
    },
    fileType: Array,
    fileTypeErrToast: {
      type: String,
      default: '上传文件格式不正确'
    },
    comType: { // 父组件区分
      type: String,
      default: ''
    },
    hasScan: { // 是否有预览功能
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 选文件
    selFile() {
      this.$refs.upload.handleClick()
    },
    // 错误提示
    overSizeFn() {
      this.$Message.info(this.overSizeToast)
      return false
    },
    fileTypeErrFn() {
      this.$Message.info(this.fileTypeErrToast)
      return false
    },
    // 事件
    beforeUpload(file) {
      const _this = this
      if (file.size > 10 * 1024 * 1024) {
        this.$Message.info(this.overSizeToast)
        return false
      }
      if (this.fileType !== undefined) {
        const fileType = file.name.split('.').pop().toUpperCase()
        const enableTypes = this.fileType.map(item => item.toUpperCase())
        if (!enableTypes.includes(fileType)) {
          this.fileTypeErrFn()
          return false
        }
      }
      this.file = file
      this.fileName = this.file.name
      // 前端预览图片
      var fr = new FileReader()
      fr.onload = function(evt) {
        _this.fileurl = evt.target.result
      }
      fr.readAsDataURL(this.file)
      if (this.stopUpload) {
        this.$emit('beforeUpload', file)
        return false
      }
    },
    successUpload(res, file, fileList) {
      this.$emit('successUpload', res, file, fileList)
      this.$emit('changeTips', false)
    },
    errorUpload(error, file, fileList) {
      this.$emit('changeTips', true)
      this.$emit('successUpload', error, file, fileList)
    },
    setFileName(obj) { // 单独设置名字
      this.showImg = false
      this.fileName = obj.name
      this.fileurl = obj.url
    },
    scanImg() {
      this.showImg = !this.showImg
    },
    clickOut() {
      if (this.showImg) {
        this.showImg = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.link-btn {
  position: relative;
  .scan-img {
    position: absolute;
    width: 140px;
    height: 140px;
    right: 15px;
    top: 26px;
    box-shadow: 0px 2px 8px 4px rgba(135, 150, 176, 0.15);
    cursor: default;
  }
}
.scan-btn {
  display: inline-block;
  margin: 0 20px 0 10px;
  text-decoration: underline;
}
</style>
